// extracted by mini-css-extract-plugin
module.exports = {"Image":"Image_Image__Bs0-1","greyscale":"Image_greyscale__3awwF"};